import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import React, { useContext, useMemo, createContext } from "react";
//Limitless imports
import { useTranslationHook } from "./TranslationHook";
export var TranslationContext = createContext({});
export var TranslationProvider = function TranslationProvider(_ref) {
  var children = _ref.children,
      resourceBundle = _ref.resourceBundle;
  var hook = useTranslationHook(resourceBundle);
  var context = useMemo(function () {
    return _objectSpread({
      resourceBundle: resourceBundle
    }, hook);
  }, [hook.resourceBundle]);
  return /*#__PURE__*/React.createElement(TranslationContext.Provider, {
    value: context
  }, children);
};
export var useTranslation = function useTranslation() {
  return useContext(TranslationContext);
};
TranslationProvider.defaultProps = {
  resourceBundle: {}
};